import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { BudgetRequestAdjustmentTypeEnum } from '@zaoblako/shared/modules/task/enum/budget-request-adjustment-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link BudgetRequestAdjustmentTypeEnum} enumeration values */
export const BudgetRequestAdjustmentTypeEnumI18n: EnumI18nInterface<BudgetRequestAdjustmentTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [BudgetRequestAdjustmentTypeEnum.INCREASE]: 'Увеличить',
    [BudgetRequestAdjustmentTypeEnum.DECREASE]: 'Уменьшить',
  },
  [I18nLocalesEnum.EN_US]: {
    [BudgetRequestAdjustmentTypeEnum.INCREASE]: 'Increase',
    [BudgetRequestAdjustmentTypeEnum.DECREASE]: 'Decrease',
  },
};
